import React, { useEffect, useState } from "react";

import {
  ActionIcon,
  Center,
  Flex,
  Menu,
  Table,
  Text,
  Title,
} from "@mantine/core";
import { IconDotsVertical, IconEdit } from "@tabler/icons-react";

import moment from "moment";
// import useStyles from "./stylesComponents";
import { useDisclosure } from "@mantine/hooks";
// import RenameFileModal from "./RenameFileModal";
// import RecordNotFound from "../RecordNotFound";
// import OpenFileModal from "./OpenFileModal";
import { HiOutlineDotsVertical } from "react-icons/hi";
import SkypointStaffOpenFileModal from "./SkypointStaffOpenFileModal";
import RecordNotFound from "../RecordNotFound";
import useStyles from "./style";
import SkypointStaffDeleteFileModal from "./SkypointStaffDeleteFileModal";
import SkypointStaffRenameFileModal from "./SkypointStaffRenameFileModal";
import { fileExtension } from "../../utils";

function SkypointStaffFileItem({ data, userId, userType }) {
  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);
  const [Fileopened, { open: openFile, close: closeFile }] =
    useDisclosure(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [Deleteopened, { open: deleteOpen, close: deleteClose }] =
    useDisclosure(false);

  const [menu, setMenu] = useState(false);

  let extension =
    fileExtension(data?.fileUrl);
  let imagePath =
    extension === "pdf"
      ? "/assets/images/pdf-svg.png"
      : ["jpeg", "JPEG", "JPG", "PNG", "GIF", "jpg", "png", "gif"].includes(
          extension
        )
      ? "/assets/images/picture-svg.png"
      : extension === "docx" || extension === "doc"
      ? "/assets/images/doc.png"
      : extension === "xlsx" || extension === "xls"
      ? "/assets/images/xls.png"
      : "/assets/images/document-svg.png";

  return (
    // <div className={classes.folderItem }>

    <div
      // className={`${classes.folderItem} ${
      //   data?.expired === true ? "" : ""
      // }`}
      className={`${classes.folderItem} ${data?.expired === true ? "" : ""}`}
      style={{
        // opacity: data?.expired === true ? 0.4 : 1,
        opacity: 1,
      }}
    >
      <div
        className={classes.column}
        // onClick={() => {
        //   setSelectedItem(data);
        //   openFile();
        // }}
      >
        <div className={classes.verticalIconContainer}>
          {/* <Menu shadow="md" width={200} disabled={data?.expired ? true : false}> */}
          <Menu
            shadow="md"
            width={200}
            // disabled={false}
            // onClick={(e) => {
            //   e.stopPropagation();
            //   setMenu(!menu);
            // }}
            // opened={menu}
          >
            <Menu.Target>
              <HiOutlineDotsVertical size={20} style={{ cursor: "pointer" }} />
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item
                onClick={() => {
                  setSelectedItem(data);
                  openFile();
                }}
                icon={
                  <img
                    src="/assets/images/open.png"
                    alt="open"
                    className={classes.folderMenuIcon}
                  />
                }
                // disabled={data?.expired ? true : false}
                disabled={false}
              >
                Open
              </Menu.Item>
              <Menu.Item
                onClick={() => {
                  fetch(data?.fileUrl).then((response) => {
                    response.blob().then((blob) => {
                      const fileURL = window.URL.createObjectURL(blob);
                      let alink = document.createElement("a");
                      alink.href = fileURL;
                      alink.download = data?.name;
                      alink.click();
                    });
                  });
                }}
                icon={
                  <img
                    src="/assets/images/downloadFolder.png"
                    alt="download"
                    className={classes.folderMenuIcon}
                  />
                }
                // disabled={data?.expired ? true : false}
                disabled={false}
              >
                Download
              </Menu.Item>
              <Menu.Item
                onClick={() => {
                  setSelectedItem(data);
                  open();
                }}
                icon={
                  <img
                    src="/assets/images/editFolder.png"
                    alt="edit"
                    className={classes.folderMenuIcon}
                  />
                }
              >
                Rename
              </Menu.Item>
              <Menu.Item
                onClick={async () => {
                  // await deleteFile(data?.id, data?.folder?.id);
                  deleteOpen();
                  setSelectedItem(data);
                }}
                icon={
                  <img
                    src="/assets/images/deleteFolder.png"
                    alt="delete"
                    className={classes.folderMenuIcon}
                  />
                }
                style={{ color: "red" }}
              >
                Delete
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>

        <div
          className={classes.filePreview}
          onClick={() => {
            setSelectedItem(data);
            openFile();
          }}
        >
          {/* <DocViewer
            style={{ width: 150, height: 150 }}
            config={{
              header: { disableHeader: true },
            }}
            key={data?._id}
            docum<Popover width={200} position="bottom" withArrow shadow="md">
      <Popover.Target>
        <Button>Toggle popover</Button>
      </Popover.Target>
      <Popover.Dropdown>
        <Text size="xs">This is uncontrolled popover, it is opened when button is clicked</Text>
      </Popover.Dropdown>
    </Popover>ents={[
              {
                uri: data?.fileUrl,
                fileType:
                  fileExtension(data?.fileUrl),
              },
            ]}
            pluginRenderers={DocViewerRenderers}
          /> */}
          <img src={imagePath} className={classes.folderBig} alt="folder" />
        </div>
      </div>
      <Flex direction={"column"} align={"center"} justifyContent={"center"}>
        <Title
          order={5}
          onClick={() => {
            setSelectedItem(data);
            openFile();
          }}
        >
          {data?.name?.length > 14
            ? data?.name?.slice(0, 14) + "..."
            : data?.name}
          {/* {data?.name?.slice(0, 15) + "..."} */}
        </Title>

        <Text
          onClick={() => {
            setSelectedItem(data);
            openFile();
          }}
          className={classes.folderDateText}
          fz="xs"
          weight={"bolder"}
        >
          {moment(data?.createdAt).format("MMMM DD, YYYY")}
        </Text>

        {data?.expired === true && moment(data?.expiry).isValid() ? (
          <Text className={classes.expiryDateText} fz="xs" weight={"bolder"}>
            Expired: {moment(data?.expiry).format("MMMM DD, YYYY")}
          </Text>
        ) : (
          data?.expiry &&
          moment(data?.expiry).isValid() && (
            <Text className={classes.expiryDateText} fz="xs" weight={"bolder"}>
              Expiry: {moment(data?.expiry).format("MMMM DD, YYYY")}
            </Text>
          )
        )}
      </Flex>
      <SkypointStaffRenameFileModal
        opened={opened}
        onclose={() => {
          close();
        }}
        title={"Rename File"}
        data={selectedItem}
        userId={userId}
        userType={userType}
      />
      <SkypointStaffOpenFileModal
        opened={Fileopened}
        onclose={() => {
          closeFile();
        }}
        title={""}
        data={selectedItem}
      />
      <SkypointStaffDeleteFileModal
        opened={Deleteopened}
        onclose={() => {
          deleteClose();
        }}
        title={"Delete File"}
        data={selectedItem}
        userId={userId}
        userType={userType}
      />
    </div>
  );
}

// const StaffFileTable = ({ data, client }) => {
//   const { classes } = useStyles();
//   const [opened, { open, close }] = useDisclosure(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [Fileopened, { open: openFile, close: closeFile }] =
//     useDisclosure(false);
//   const [Deleteopened, { open: deleteOpen, close: deleteClose }] =
//     useDisclosure(false);

//     data.forEach((item) => {
//       const extension = item?.fileUrl?.split(".").pop().toLowerCase(); // Get extension and normalize

//       const imagePath =
//         extension === "pdf"
//           ? "/assets/images/pdf-svg.png"
//           : ["jpeg", "jpg", "png", "gif"].includes(extension)
//           ? "/assets/images/picture-svg.png"
//           : ["docx", "doc"].includes(extension)
//           ? "/assets/images/doc.png"
//           : ["xlsx", "xls"].includes(extension)
//           ? "/assets/images/xls.png"
//           : "/assets/images/document-svg.png";

//     });

//   //   let extension =
//   //   data?.fileUrl?.split(".")[data?.fileUrl?.split(".")?.length - 1];
//   // let imagePath =
//   //   extension === "pdf"
//   //     ? "/assets/images/pdf-svg.png"
//   //     : ["jpeg", "JPEG", "JPG", "PNG", "GIF", "jpg", "png", "gif"].includes(
//   //         extension
//   //       )
//   //     ? "/assets/images/picture-svg.png"
//   //     : extension === "docx" || extension === "doc"
//   //     ? "/assets/images/doc.png"
//   //     : extension === "xlsx" || extension === "xls"
//   //     ? "/assets/images/xls.png"
//   //     : "/assets/images/document-svg.png";

//   const ths = (
//     <tr>
//       <th style={{ minWidth: "400px" }}>Name</th>
//       <th style={{ minWidth: "200px" }}>Date</th>
//       <th style={{ minWidth: "200px" }}>Expiry Date</th>
//       {/* <th style={{ minWidth: "150px" }}>File Extension</th> */}
//       {/* <th style={{ minWidth: "250px" }}>Location</th> */}
//       {/* <th style={{ minWidth: "250px" }}>Actions</th> */}
//     </tr>
//   );
//   return (
//     <>
//       {data?.length > 0 ? (
//         <Table striped fontSize={"md"}>
//           <thead>{ths}</thead>
//           <tbody>
//             {data?.map((val, index) => (
//               <tr key={val?._id}>
//                 <td>
//                   <div className={classes.imgName}>
//                     <img
//                       src={imagePath}
//                       alt="file"
//                       className={classes.fileImageRow}
//                     />{" "}
//                     <p>{val?.name}</p>
//                     {/* <ActionIcon
//                       color="yellow"
//                       variant="light"
//                       onClick={(e) => {
//                         setSelectedItem(val);
//                         open(e);
//                       }}
//                     >
//                       <IconEdit />
//                     </ActionIcon> */}
//                   </div>
//                 </td>
//                 {/* <td>
//                   {val?.fileUrl
//                     ?.split(".")
//                     [val?.fileUrl?.split(".")?.length - 1]?.toUpperCase()}
//                 </td> */}
//                 <td>{`${moment(val?.createdAt).format("MM/DD/YYYY")}`}</td>
//                 <td className={classes.expiryDateText}>
//                   {val?.expiry
//                     ? `${moment(val?.expiry).format("MM/DD/YYYY")}`
//                     : "-"}
//                 </td>
//                 {/* <td>{val?.folder ? val?.folder?.name : "-"}</td>
//                 <td>
//                   <div className={classes.row} style={{ gap: 5 }}>
//                     <img
//                       onClick={() => {
//                         setSelectedItem(val);
//                         openFile();
//                       }}
//                       src="/assets/images/eye.png"
//                       alt="view"
//                       style={{ width: 30, cursor: "pointer" }}
//                     />
//                     <img
//                       onClick={() => {
//                         fetch(val?.fileUrl).then((response) => {
//                           response.blob().then((blob) => {
//                             const fileURL = window.URL.createObjectURL(blob);
//                             let alink = document.createElement("a");
//                             alink.href = fileURL;
//                             alink.download = val?.name;
//                             alink.click();
//                           });
//                         });
//                       }}
//                       src="/assets/images/downloadFile.png"
//                       alt="download"
//                       className={classes.actionsImageRow}
//                     />
//                     <img
//                       onClick={async () => {
//                         setSelectedItem(val);
//                         deleteOpen();
//                       }}
//                       src="/assets/images/deleteFolder.png"
//                       alt="delete"
//                       style={{ width: 30, cursor: "pointer" }}
//                     />
//                   </div>
//                 </td> */}
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       ) : (
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "space-evenly",
//             height: "60vh",
//             gap: "8rem",
//             textAlign: "center",
//             margin: "0 auto",
//           }}
//         >
//           <RecordNotFound />
//           <p className={classes.notFoundText}>
//             You don&apos;t have any files uploaded to this folder, click on
//             “upload documents” to add.
//           </p>
//         </div>
//       )}
//       <StaffRenameFileModal
//         opened={opened}
//         onclose={() => {
//           close();
//         }}
//         title={"Rename File"}
//         data={selectedItem}
//         client={client}
//       />
//       <StaffOpenFileModal
//         opened={Fileopened}
//         onclose={() => {
//           closeFile();
//         }}
//         title={""}
//         data={selectedItem}
//       />
//       <StaffDeleteFileModal
//         opened={Deleteopened}
//         onclose={() => {
//           deleteClose();
//         }}
//         title={"Delete File"}
//         data={selectedItem}
//         client={client}
//       />
//     </>
//   );
// };

const SkypointStaffFileTable = ({ data, client }) => {
  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [Fileopened, { open: openFile, close: closeFile }] =
    useDisclosure(false);
  const [Deleteopened, { open: deleteOpen, close: deleteClose }] =
    useDisclosure(false);

  const ths = (
    <tr>
      <th style={{ minWidth: "400px" }}>Name</th>
      <th style={{ minWidth: "200px" }}>Date</th>
      <th style={{ minWidth: "200px" }}>Expiry Date</th>
    </tr>
  );

  return (
    <>
      {data?.length > 0 ? (
        <Table striped fontSize={"md"}>
          <thead>{ths}</thead>
          <tbody>
            {data?.map((val) => {
              const extension = fileExtension(val?.fileUrl).toLowerCase();

              const imagePath =
                extension === "pdf"
                  ? "/assets/images/pdf-svg.png"
                  : ["jpeg", "jpg", "png", "gif"].includes(extension)
                  ? "/assets/images/picture-svg.png"
                  : ["docx", "doc"].includes(extension)
                  ? "/assets/images/doc.png"
                  : ["xlsx", "xls"].includes(extension)
                  ? "/assets/images/xls.png"
                  : "/assets/images/document-svg.png";

              return (
                <tr
                  key={val?._id}
                  onClick={() => {
                    setSelectedItem(val);
                    openFile();
                  }}
                >
                  <td>
                    <div className={classes.imgName}>
                      <img
                        src={imagePath}
                        alt="file"
                        className={classes.fileImageRow}
                      />
                      <p>{val?.name}</p>
                    </div>
                  </td>
                  <td>{moment(val?.createdAt).format("MM/DD/YYYY")}</td>
                  <td className={classes.expiryDateText}>
                    {val?.expiry
                      ? moment(val?.expiry).format("MM/DD/YYYY")
                      : "-"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-evenly",
            height: "60vh",
            gap: "8rem",
            textAlign: "center",
            margin: "0 auto",
          }}
        >
          <RecordNotFound />
          <p className={classes.notFoundText}>
            You don&apos;t have any files uploaded to this folder, click on
            “upload documents” to add.
          </p>
        </div>
      )}

      {/* Modals */}
      <SkypointStaffRenameFileModal
        opened={opened}
        onclose={close}
        title={"Rename File"}
        data={selectedItem}
        client={client}
      />
      <SkypointStaffOpenFileModal
        opened={Fileopened}
        onclose={closeFile}
        title={""}
        data={selectedItem}
      />
      <SkypointStaffDeleteFileModal
        opened={Deleteopened}
        onclose={deleteClose}
        title={"Delete File"}
        data={selectedItem}
        client={client}
      />
    </>
  );
};

export { SkypointStaffFileItem, SkypointStaffFileTable };
